import { DateTime } from "luxon";

export const isLessThanXHoursAgo = (date: string | null, hours: number): boolean => {
  if (!date) {
    return false;
  }

  const givenDate = DateTime.fromISO(date);
  const now = DateTime.now();

  return now.diff(givenDate, "hours").hours <= hours;
};
